import React from 'react';

import WhatsAppLogo from '../../../../assets/images/whatsapp.svg';
import { useHistory } from 'react-router-dom';
import { Button, Icon } from '@polichat/flamboyant';
import { useGlotaT } from '../../../../hooks/useGlotaTranslation';

import {
  Container,
  IconLabelContainer,
  HorizontalRule,
} from './ChannelDescriptionBanner.styles';

export default function ChannelDescriptionBanner() {
  const history = useHistory();
  
  // Traduções
  const whatsappAlt = useGlotaT('spa.channels.broker.whatsappAlt');
  const whatsappLabel = useGlotaT('spa.channels.broker.whatsappLabel');
  const whatsappDescription = useGlotaT('spa.channels.broker.description');
  const addChannelButton = useGlotaT('spa.tools.addChannelButton');
  
  return (
    <>
      <Container>
        <IconLabelContainer>
          <img src={WhatsAppLogo} alt={whatsappAlt} />
          <b>{whatsappLabel}</b>
        </IconLabelContainer>

        <div>
          {whatsappDescription}
        </div>

        {/* Não está sendo utilizado por enquanto, mas vou deixar aqui caso queiramos reutilizar*/}
        {/* <Button
          color="primary"
          onClick={() => history.push('/tools/channels/add')}
          style={{
            width: '30rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <span
            style={{
              display: 'flex',
              gap: '0.1rem',
              alignItems: 'center',
            }}
          >
            <Icon icon={'poli-icon pi-add-line'} size={20} />
            <span> {addChannelButton}</span>
          </span>
          <Icon icon={'poli-icon pi-simple-arrow-down-line'} size={20} />
        </Button> */}
      </Container>
      <HorizontalRule />
    </>
  );
}
